import React from 'react'
import PropTypes from 'prop-types'

import CloseIconSVG from 'component/svgComponents/close'
import Select from 'component/Select/Select'

const INITIAL_STATE = {
    idBranch: "",
    status: "2",
    type: "2"
}

class SideFilterForm extends React.Component {
  static propTypes = {
    closeFilter: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    isUserMatriz: PropTypes.bool.isRequired,
    missionsSelectBranchs: PropTypes.array
    
  }

  state = {
    values: {
      idBranch: '',
      dtPeriod: [],
      status: '2',
      type: '2'
    },
    previousValues: {
      idBranch: '',
      dtPeriod: [],
      status: '2',
      type: '2'
    }
  }

  get typeOptions() {
    const options = [
      {
        label: "Todos",
        value: "2"
      },

      {
        label: "C050 Loja",
        value: "1"
      },

      {
        label: "C010 Supply",
        value: "0"
      },
    ] 
    return options 
  }

  get statusOptions() {

    const options = [
      {
        label: "Todos",
        value: '2',
      },
      {
        label: "Desativado",
        value: '1',
      },
      {
        label: "Ativado",
        value: '0',
      },
    ]

    return options
  }

  handleSubmit = () => {
    const { values } = this.state
    const { onSubmit } = this.props

    this.setState({
      previousValues: values
    })

    onSubmit(values)
  }

  handleChange(field, value) {
    this.setState({
      values: {
        ...this.state.values,
        [field]: value,
      }
    })
  }


  sameValues() {
    const { values, previousValues } = this.state
    let sameValues = true

    const fields = ['type', 'status']

    fields.forEach(field => {
      if (values[field] !== previousValues[field]) sameValues = false
    })

    return sameValues
  }

  cleanFilters = () => {
    const {values} = this.state
    const currentValue = {...values}
    this.setState({
      previousValues: currentValue,
      values: {...currentValue, ...INITIAL_STATE}
    })
  }

  render() {
    const {
      translate,
      closeFilter,
      show,
    } = this.props
    const { values } = this.state

    return (
      <div className={`common-report no-margin no-padding h-0`}>
        <div className='content'>
          <div
            className={`filters-overlay ${show ? 'show' : ''
              }`}
          />
          <div
            className={`filters fixed ${show ? 'open' : ''
              }`}
          >
            <div className='close' onClick={closeFilter}>
              <CloseIconSVG />
            </div>
            <h3 className='no-margin'>
              <strong>{translate('mobile.filter')}</strong>
            </h3>

            <div className='margin-bottom-double' />

            <div>
              <Select
                fill
                required
                label={translate('type')}
                options={this.typeOptions}
                onChange={(e) => this.handleChange('type', e.value)}
                value={this.typeOptions.find(({ value }) => value === values.type)}
                validateValue={(v) => (v.value || '').length > 0}
              />
            </div>


            <div>
              <Select
                fill
                required
                label={translate('status')}
                options={this.statusOptions}
                onChange={(e) => this.handleChange('status', e.value)}
                value={this.statusOptions.find(({ value }) => value === values.status)}
                validateValue={(v) => (v.value || '').length > 0}
              />
            </div>
    
            <div className='irc-supply-list-filter'>
              <button
              className='btn btn-danger-outline button-full margin-top-double'
              
              onClick={this.cleanFilters}
              type='button'
              >
              {translate('suggestions.cleanFilters')}
              </button>
              
                <button
                  className='btn btn-primary button-full margin-top-double'
                  onClick={this.handleSubmit}
                  disabled={this.sameValues()}
                  type='button'
                >
                  {translate('btn.filter')}
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default SideFilterForm
export { SideFilterForm }
